import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProfileData } from "../../types/patient/SearchPatientModal";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";

interface PatientDataState {
  patientLoading: boolean;
  patientSuccess: boolean;
  PatientError: any;
  patientData: ProfileData[];
}
const initialState: PatientDataState = {
  patientLoading: false,
  patientSuccess: false,
  PatientError: "",
  patientData: [],
};

const apiUrl = process.env.BASE_URL;

export const getPatientData = createAsyncThunk<any, { patientChy: string }>(
  "SearchPatient/getSearchPatientData",
  async ({ patientChy }, { rejectWithValue }) => {
    try {
      const payload = {chy: patientChy};
      const response = await axiosInstance.post(`${apiUrl}/patient-profile/chy`,payload);
      return response.data.profileData;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(
          "An Unknown error occurred while getting Patient's data"
        );
      }
    }
  }
);

const searchPatientSlice = createSlice({
  name: "PatientData",
  initialState,
  reducers: {
    patientDataClearSuccess: (state) => {
      state.patientSuccess = false;
    },
    patientDataClearError: (state) => {
      state.PatientError = false;
    },
    clearPatient: (state) => {
      state.patientData = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPatientData.pending, (state) => {
        state.patientLoading = true;
        state.patientSuccess = false;
        state.PatientError = null;
        state.patientData = [];
      })
      .addCase(getPatientData.fulfilled, (state, action) => {
        state.patientLoading = false;
        state.patientSuccess = true;
        state.patientData = action.payload;
      })
      .addCase(getPatientData.rejected, (state, action) => {
        state.patientLoading = false;
        state.PatientError = action.payload;
        state.patientData = [];
      });
  },
});

export const { patientDataClearSuccess, clearPatient, patientDataClearError } =
  searchPatientSlice.actions;
export default searchPatientSlice.reducer;
